export enum QueryKeys {
    ROBINS_DATA = "robins_data",
    APP_TOKENS = 'app_tokens'
}
